/*
  The back/forward cache restores a page exactly as it was left, cart markup
  included. A customer who adds an item and then presses Back to the product
  list sees the count from before the add, and the drawer still holds the old
  line items - it reads as "my item was deleted" even though the cart on the
  server is correct.

  On the cart page it is worse than cosmetic: quantity updates address line
  items by their 1-based index, so acting on a stale list can change the wrong
  line. That page is reloaded rather than patched.

  The theme already re-renders these two sections after every cart change. This
  does the same on a restore, but without opening the drawer the way
  CartNotification.renderContents does.
*/
(function () {
  var SECTION_IDS = ['cart-notification', 'cart-notification-count'];

  function cartPath() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function onCartPage() {
    var base = cartPath();
    return window.location.pathname === base || window.location.pathname === base + '/';
  }

  /*
    Returns the item count the current markup is showing, or null when it cannot
    be read. The cart page carries no header bubble, so its line-item quantity
    inputs are summed instead - and those inputs are only trusted there, because
    the quick order list uses the same name elsewhere.
  */
  function renderedCount() {
    if (onCartPage()) {
      var inputs = document.querySelectorAll('input[name="updates[]"]');
      if (!inputs.length) return null;

      var total = 0;
      for (var i = 0; i < inputs.length; i++) {
        var quantity = parseInt(inputs[i].value, 10);
        if (isNaN(quantity)) return null;
        total += quantity;
      }
      return total;
    }

    var bubble = document.getElementById('cart-notification-count');
    if (!bubble) return null;

    var count = parseInt((bubble.textContent || '').trim(), 10);
    return isNaN(count) ? null : count;
  }

  function sectionInnerHTML(html) {
    var section = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('.shopify-section');

    return section ? section.innerHTML : null;
  }

  function refreshCartSections() {
    return fetch(window.location.pathname + '?sections=' + SECTION_IDS.join(','))
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        SECTION_IDS.forEach(function (id) {
          var target = document.getElementById(id);
          if (!target || !sections[id]) return;

          var html = sectionInnerHTML(sections[id]);
          if (html !== null) target.innerHTML = html;
        });
      });
  }

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;

    fetch(cartPath() + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var shown = renderedCount();

        /* Nothing changed while the page sat in the cache - keep the instant Back. */
        if (shown !== null && shown === cart.item_count) return;

        if (onCartPage()) {
          window.location.reload();
          return;
        }

        return refreshCartSections();
      })
      .catch(function () {
        /* Offline or a blocked request: leave the restored markup as it is. */
      });
  });
})();
